var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencilD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.401,
    height: 15,
    viewBox: "0 0 9.401 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Selfcare_Edit_blue",
    transform: "translate(-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M30.93.719,31.344,0l2.133,1.232-.415.719Z",
    transform: "translate(-15.077)",
    fill: "#e10092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M16.122,3.1l.719.415L10.734,14.088l.7.4L17.537,3.912l.719.415-6.522,11.3L9.6,14.391Z",
    transform: "translate(-0.412 -2.128)",
    fill: "#e10092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M9.117,40.382,9,42.763l2-1.291Z",
    transform: "translate(0 -27.763)",
    fill: "#e10092"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilD);
export default __webpack_public_path__ + "static/media/edit_pencil-d.f3eee97335043e1f841641d8fbc9e64f.svg";
export { ForwardRef as ReactComponent };